import { gamingAPI } from '../services/api';

const percentFloor = new Map();
const currentFloor = new Map();
const stepsFloor = new Map();
const rank = { pending: 0, active: 1, done: 2 };

export async function fetchBootProgress(sessionId) {
  const data = await gamingAPI.getBootProgress(sessionId);
  if (data?.failed) return data;
  if (!data || (data.ok === false && !data.current && !(data.percent > 0))) {
    throw new Error('empty boot progress');
  }
  return data;
}

export function floorBootView(sessionKey, boot, fallbackPercent = 0) {
  if (!sessionKey) {
    return {
      percent: fallbackPercent,
      current: boot?.current || '',
      steps: boot?.steps || [],
    };
  }
  if (boot?.failed) {
    percentFloor.delete(sessionKey);
    currentFloor.delete(sessionKey);
    stepsFloor.delete(sessionKey);
    return {
      percent: Math.min(20, Number(boot.percent) || 20),
      current: boot.current || 'The GPU did not start',
      steps: boot.steps || [],
    };
  }
  const incoming = Number.isFinite(parseInt(boot?.percent, 10))
    ? parseInt(boot.percent, 10)
    : 0;
  const prevPct = percentFloor.get(sessionKey) || 0;
  const percent = Math.max(prevPct, incoming, fallbackPercent || 0);
  percentFloor.set(sessionKey, percent);
  if (boot?.current && incoming >= prevPct) {
    currentFloor.set(sessionKey, boot.current);
  }
  const prevSteps = stepsFloor.get(sessionKey) || [];
  const source = boot?.steps?.length ? boot.steps : prevSteps;
  const merged = source.map((step) => {
    const old = prevSteps.find((s) => s.id === step.id);
    if (old && (rank[old.status] || 0) > (rank[step.status] || 0)) {
      return { ...step, status: old.status };
    }
    return step;
  });
  if (merged.length) stepsFloor.set(sessionKey, merged);
  return {
    percent,
    current: currentFloor.get(sessionKey) || boot?.current || '',
    steps: merged.length ? merged : source,
  };
}
